import * as svg from "../../../assets/arrow-top-right.svg";

import {iconBuilder} from "./iconBuilder";

export const ArrowTopRightIcon = iconBuilder(svg, "ArrowTopRightIcon", "0 0 8 8");
